import toast from '.';

toast.showToast = toast.show;

export default toast;
